import UsersRepository from "./repositories/usersRepository";
import TagRepository from "./repositories/tagRepository";

const repositories = {
  users: UsersRepository,
  tag: TagRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
